import React, { useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import { SubNavGestaoDeCadastros } from "./subnavs/GestaoDeCadastros";

import { useUserInfor } from "../../../Context/User/";
import {
    mostrarDropdownDeTelas,
    mostrarNavDeTela,
} from "../../../Validations/UsuarioTela";
import { ACESSOS } from "../../../Routes/Acessos";
import GestaoProdutosSubnav from "../GestaoProdutos";
import FinanceiroSubnav from "../Financeiro";

export default function GeralTab() {
    const { UserInfor, OrgInfor } = useUserInfor();
    //menu-item-open-dropdown menu-item-hover
    const [showDropdown, setshowDropdown] = useState("");

    const [showDropdownProdutos, setshowDropdownProdutos] = useState("");
    const [showDropdownFinanceiro, setshowDropdownFinanceiro] = useState("");

    const capysEng = "6379F504-FCF5-4e99-B7E2-92ACF6878448";
    const capysDemo = "09EC9659-6C18-485D-BCAC-706D5B040D30";

    return (
        <div className="tab-pane py-5 p-lg-0 show active" id="GeralTab">
            <div
                id="kt_header_menu"
                className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
            >
                <ul className="menu-nav">
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.DASHBOARD.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.DASHBOARD.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Dashboard</span>
                            </NavLink>
                        </li>
                    )}
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_CLIENTES.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.GESTAO_CLIENTES.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Clientes
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarDropdownDeTelas(
                        [
                            ACESSOS.GERAL.MODAIS.MOTIVO_CANCELAMENTO.ID_TELA,
                            ACESSOS.GERAL.MODAIS.SUBCATEGORIA.ID_TELA,
                            ACESSOS.GERAL.MODAIS.TIPO_AGENDAMENTO.ID_TELA,
                            ACESSOS.GERAL.MODAIS.TIPO_CANAL_ATENDIMENTO.ID_TELA,
                            ACESSOS.GERAL.MODAIS.TIPO_DOCUMENTO.ID_TELA,
                            ACESSOS.GERAL.MODAIS.TIPO_RECORRENCIA.ID_TELA,
                            ACESSOS.GERAL.MODAIS.TIPO_RELACAO_CLIENTE.ID_TELA,
                            ACESSOS.GERAL.MODAIS.TEMPLATES_MODULO.ID_TELA,
                            ACESSOS.GERAL.TELAS.CONFIG_EMAIL.ID_TELA,
                            ACESSOS.GERAL.TELAS.CONFIG_GERAL.ID_TELA,
                            ACESSOS.GERAL.TELAS.CATEGORIA_ATENDIMENTO.GESTAO
                                .ID_TELA,
                        ],
                        UserInfor.TELAS
                    ) && (
                        <ClickAwayListener
                            mouseEvent="onMouseDown"
                            touchEvent="onTouchEnd"
                            onClickAway={() => {
                                setshowDropdown("");
                            }}
                        >
                            <li
                                className={`menu-item menu-item-submenu ${showDropdown}`}
                            >
                                <span
                                    className="menu-link menu-toggle"
                                    onClick={() => {
                                        if (
                                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                                navigator.userAgent
                                            )
                                        ) {
                                            if (
                                                document.getElementsByClassName(
                                                    "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                ).length > 0
                                            )
                                                setshowDropdown("");
                                            else
                                                setshowDropdown(
                                                    "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                );
                                        } else {
                                            if (
                                                document.getElementsByClassName(
                                                    "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                ).length > 0
                                            )
                                                setshowDropdown("");
                                            else
                                                setshowDropdown(
                                                    "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                );
                                        }
                                    }}
                                >
                                    <span className="menu-text">
                                        Gestão de Cadastros
                                    </span>
                                    <span className="menu-desc"></span>
                                    <i className="menu-arrow"></i>
                                </span>

                                <SubNavGestaoDeCadastros />
                            </li>
                        </ClickAwayListener>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_USUARIOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.GESTAO_USUARIOS.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Usuarios
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_GRUPOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.GESTAO_GRUPOS.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    Gestão de Grupos
                                </span>
                            </NavLink>
                        </li>
                    )}
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_PRODUTOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <ClickAwayListener
                            mouseEvent="onMouseDown"
                            touchEvent="onTouchEnd"
                            onClickAway={() => {
                                setshowDropdownProdutos("");
                            }}
                        >
                            <li
                                className={`menu-item menu-item-submenu ${showDropdownProdutos}`}
                            >
                                <span
                                    className="menu-link menu-toggle"
                                    onClick={() => {
                                        if (
                                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                                navigator.userAgent
                                            )
                                        ) {
                                            if (
                                                document.getElementsByClassName(
                                                    "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                ).length > 0
                                            )
                                                setshowDropdownProdutos("");
                                            else
                                                setshowDropdownProdutos(
                                                    "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                );
                                        } else {
                                            if (
                                                document.getElementsByClassName(
                                                    "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                ).length > 0
                                            )
                                                setshowDropdownProdutos("");
                                            else
                                                setshowDropdownProdutos(
                                                    "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                );
                                        }
                                    }}
                                >
                                    <span className="menu-text">
                                        Gestão de Produtos
                                    </span>
                                    <span className="menu-desc"></span>
                                    <i className="menu-arrow"></i>
                                </span>

                                <GestaoProdutosSubnav />
                            </li>
                        </ClickAwayListener>
                    )}
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.GESTAO_PRODUTOS.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <ClickAwayListener
                            mouseEvent="onMouseDown"
                            touchEvent="onTouchEnd"
                            onClickAway={() => {
                                setshowDropdownFinanceiro("");
                            }}
                        >
                            <li
                                className={`menu-item menu-item-submenu ${showDropdownFinanceiro}`}
                            >
                                <span
                                    className="menu-link menu-toggle"
                                    onClick={() => {
                                        if (
                                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                                navigator.userAgent
                                            )
                                        ) {
                                            if (
                                                document.getElementsByClassName(
                                                    "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                ).length > 0
                                            )
                                                setshowDropdownFinanceiro("");
                                            else
                                                setshowDropdownFinanceiro(
                                                    "menu-item-open menu-item-open-dropdown menu-item-hover"
                                                );
                                        } else {
                                            if (
                                                document.getElementsByClassName(
                                                    "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                ).length > 0
                                            )
                                                setshowDropdownFinanceiro("");
                                            else
                                                setshowDropdownFinanceiro(
                                                    "menu-item-rel menu-item-open-dropdown menu-item-hover"
                                                );
                                        }
                                    }}
                                >
                                    <span className="menu-text">
                                        Financeiro
                                    </span>
                                    <span className="menu-desc"></span>
                                    <i className="menu-arrow"></i>
                                </span>

                                <FinanceiroSubnav />
                            </li>
                        </ClickAwayListener>
                    )}
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.TRIAGEM.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.TRIAGEM.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Triagem</span>
                            </NavLink>
                        </li>
                    )}
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.AGENDA.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.AGENDA.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">Agenda</span>
                            </NavLink>
                        </li>
                    )}

                    {(OrgInfor.ID_ORGANIZACAO === capysEng ||
                        OrgInfor.ID_ORGANIZACAO === capysDemo) &&
                        mostrarNavDeTela(
                            ACESSOS.GERAL.TELAS.BOARD_DEVOPS.ID_TELA,
                            UserInfor.TELAS
                        ) && (
                            <li className="menu-item">
                                <NavLink
                                    to={
                                        ACESSOS.GERAL.TELAS.BOARD_DEVOPS.DS_PATH
                                    }
                                    exact
                                    activeClassName="active"
                                    className="menu-link"
                                >
                                    <span className="menu-text">DevOps</span>
                                </NavLink>
                            </li>
                        )}

                    {OrgInfor.COD_ERP_INTEGRACAO === "UAU" &&
                        mostrarNavDeTela(
                            ACESSOS.GERAL.TELAS.BUSCA_DE_CLIENTES_UAU.ID_TELA,
                            UserInfor.TELAS
                        ) && (
                            <li className="menu-item">
                                <NavLink
                                    to={
                                        ACESSOS.GERAL.TELAS
                                            .BUSCA_DE_CLIENTES_UAU.DS_PATH
                                    }
                                    exact
                                    activeClassName="active"
                                    className="menu-link"
                                >
                                    <span className="menu-text">
                                        Busca de Cliente
                                    </span>
                                </NavLink>
                            </li>
                        )}
                    {mostrarNavDeTela(
                        ACESSOS.GERAL.TELAS.EXECUTAR_ETL.ID_TELA,
                        UserInfor.TELAS
                    ) && (
                        <li className="menu-item">
                            <NavLink
                                to={ACESSOS.GERAL.TELAS.EXECUTAR_ETL.DS_PATH}
                                exact
                                activeClassName="active"
                                className="menu-link"
                            >
                                <span className="menu-text">
                                    ETL - Importar Dados
                                </span>
                            </NavLink>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
